import * as React from "react";
import StandardLayoutInternal from "./StandardLayoutInternal";
import { connect } from "react-redux";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import {bindActionCreators} from "redux";
import {onToggleSidebar} from "actions/sidebar";
import GlobalState from "globalState";
import {clearUnhandledErrorAction} from "./reducers";

interface StandardLayoutDispatchers {
    onErrorClose(): void;
}

const StandardLayout = connect(
    (state: GlobalState) => {
        return {
            unhandledError: state.unhandledError
        };
    },
    (dispatch): StandardLayoutDispatchers => {
        return {
            onErrorClose: bindActionCreators(clearUnhandledErrorAction, dispatch)
        };
    }
)(StandardLayoutInternal);

export default StandardLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/StandardLayout/StandardLayout.tsx